import type React from "react";

import { Box, FormControl, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { MUISelect } from "shared/atoms/MUI";

export type DateFilterValue = "last_30_days" | "last_3_months" | "last_6_months" | "last_12_months" | "all";

interface DateFilterProps {
  value: DateFilterValue;
  onChange: (value: DateFilterValue) => void;
}

export const DateFilter: React.FC<DateFilterProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const options = [
    { label: t("invitations.table.filter_last_30_days"), value: "last_30_days" },
    { label: t("invitations.table.filter_last_3_months"), value: "last_3_months" },
    { label: t("invitations.table.filter_last_6_months"), value: "last_6_months" },
    { label: t("invitations.table.filter_last_12_months"), value: "last_12_months" },
    { label: t("invitations.table.filter_all"), value: "all" },
  ];

  return (
    <Box sx={{ display: "flex", alignItems: "center", marginLeft: "auto", gap: 1 }}>
      <Typography variant="body2">{t("invitations.table.show_invites_from")}</Typography>
      <FormControl sx={{ minWidth: 150 }} size="small">
        <MUISelect
          id="date-filter"
          value={value}
          onChange={e => onChange(e.target.value as DateFilterValue)}
          size="small"
          variant="outlined"
          options={options}
        />
      </FormControl>
    </Box>
  );
};
